<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar"></div>

        <div class="content">
          <div class="content-header">
            <div>
              <h6 *ngIf="quiz.title">
                <nb-icon
                  *ngIf="quiz.type === 'radio'"
                  icon="checkmark-circle-outline"
                ></nb-icon>
                <nb-icon
                  *ngIf="quiz.type === 'check'"
                  icon="checkmark-square-outline"
                ></nb-icon>
                <nb-icon
                  *ngIf="quiz.type === 'input'"
                  icon="file-outline"
                ></nb-icon>
                <nb-icon
                  *ngIf="quiz.type === 'document'"
                  icon="file-text-outline"
                ></nb-icon>

                <a class="link" (click)="testQuiz(quiz)">
                  {{ quiz.title }}
                </a>
              </h6>
            </div>
          </div>

          <div class="view-content">
            <ngx-view-tags
              [tags]="quiz.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>

            <div class="button-actions">
              <nb-actions size="none">
                <nb-action>
                  <i class="fas fa-thumbs-up" style="color: #0095ff"></i>
                  <span> {{ quiz.noLiked | number }} </span>
                </nb-action>

                <nb-action>
                  <nb-icon
                    status="success"
                    class="action-icon"
                    icon="eye-outline"
                  ></nb-icon>
                  <span> {{ quiz.noAttempt | number }} </span>
                </nb-action>

                <nb-action>
                  <nb-icon
                    status="warning"
                    class="action-icon"
                    icon="percent-outline"
                  ></nb-icon>
                  <span>
                    {{
                      quiz.noAttempt > 0
                        ? ((quiz.noCorrect * 100) / quiz.noAttempt).toFixed(0)
                        : 0
                    }}
                  </span>
                </nb-action>
              </nb-actions>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + quiz.id"
        (click)="loadButtonAction(quiz)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
</nb-card>
